(($, window, document, undefined) => {
    $(() => {

        const onCommentModalOpen = () => {
            $('.open-comment-modal').on({
                'click': (e) => {
                    const $target = $(e.target)
                    e.preventDefault()
                    const commentId = $target.data('comment-id')

                    const clonedComment = $(`#comment-${commentId}`).clone()
                    clonedComment.find('.comment__reply').remove()

                    $('#modal-comment-content').empty().append(clonedComment)
                    $('#modal-comment-form-wrap input[name="comment_parent"]').attr('value', commentId)
                    $('#modal-comment').fadeIn()
                }
            })
        }

        const onCommentModalClose = () => {
            $('#modal-comment-close').on({
                'click': () => {
                    $('#modal-comment').fadeOut();
                }
            });
        }

        const init = () => {
            onCommentModalOpen()
            onCommentModalClose()
        }

        init();

    });
})(window['jQuery'], window, document);
